// api domain
// export const domain = 'http://localhost:3011/api'
// export const domainSocket = 'http://localhost:3011'
export const domain = 'https://www.servisbizde.com/api'
export const domainSocket = 'https://www.servisbizde.com'